import { useContext } from 'react';

import { LastAlarmContext } from '../context';
import { LastAlarmContextProps } from '../context/types';

export function useLastAlarm(): LastAlarmContextProps {
    return useContext(LastAlarmContext);
}
